import i18n from '@dms/i18n';

/** The owner order is reachable through the owner vehicle link next to the field, not by its ID. */
export const getFactoryReferenceInUseMessage = () =>
  i18n.t('entity.newVehicle.order.factoryReferenceInUseByAnotherOrder', {
    defaultValue: 'This order reference is already used by another vehicle order.',
  });
